import React from "react";
import Image from "@/components/Image";

interface LiveButtonProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
  disabled?: boolean;
  label?: string;
  variant?: "solid" | "outline";
  size?: "default" | "compact";
  ariaLabel?: string;
  ariaExpanded?: boolean;
}

const LiveButton = ({
  onClick,
  className = "",
  disabled = false,
  label = "Live",
  variant = "solid",
  size = "default",
  ariaLabel,
  ariaExpanded,
}: LiveButtonProps) => {
  if (variant === "outline") {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-expanded={ariaExpanded}
        className={`relative inline-flex items-center justify-center rounded-full border-2 border-[#7DC146] bg-white px-8 py-2 ${
          disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer hover:bg-[#F7FFF3]"
        } ${className}`}
      >
        <span className="relative inline-flex items-center justify-center">
          <Image
            src="/assets/live-tutor-logo.png"
            alt="Live Tutor"
            width={44}
            height={44}
            className="pointer-events-none absolute left-[29px] -top-[28px] -translate-x-1/2"
            optimizedWidth={150}
          />
          <span className="display-text-bold text-xl text-[#7DC146]">{label}</span>
        </span>
      </button>
    );
  }

  const isCompact = size === "compact";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      className={`relative inline-flex items-center justify-center rounded-full bg-[#7DC146] ${
        isCompact ? "px-6 py-2" : "px-8 py-2"
      } ${
        disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
      } ${className}`}
    >
      <span className="relative inline-flex items-center justify-center">
        <Image
          src="/assets/live-tutor-logo.png"
          alt="Live Tutor"
          width={isCompact ? 38 : 44}
          height={isCompact ? 38 : 44}
          className={`pointer-events-none absolute -translate-x-1/2 ${
            isCompact ? "left-[23px] -top-[23px]" : "left-[29px] -top-[28px]"
          }`}
          optimizedWidth={150}
        />
        <span className={`display-text-bold text-[#FFF9D5] ${isCompact ? "text-lg" : "text-2xl"}`}>{label}</span>
      </span>
    </button>
  );
};

export default LiveButton;
